import React from 'react'
import { ChevronsUpDown } from 'lucide-react'

export interface TitleGripProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** Offen: Titelwerkzeug bzw. Icon-Wähler steht — der Griff bleibt dann violett. */
  open?: boolean
  label: string
}

/**
 * Der **Titelgriff** (CONTEXT.md „Projekt-Kopf“): der kleine ⌃⌄-Knopf, der
 * beim Überfahren einer Zeile des Projekt-Kopfs erscheint. Er hängt links
 * hinaus bzw. rechts neben dem großen Icon und schiebt nichts zur Seite; beim
 * Überfahren und solange geöffnet trägt er den Ton des Lebensbereichs.
 *
 * @example
 * <TitleGrip label="Titel gestalten" open={toolbarOpen} onClick={toggle} />
 */
export const TitleGrip = React.forwardRef<HTMLButtonElement, TitleGripProps>(({ open = false, label, className, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    aria-label={label}
    aria-expanded={open}
    data-state={open ? 'open' : 'closed'}
    className={`title-grip${open ? ' title-grip--open' : ''}${className ? ` ${className}` : ''}`}
    {...props}
  >
    <ChevronsUpDown size={14} strokeWidth={2} aria-hidden="true" />
  </button>
))
TitleGrip.displayName = 'TitleGrip'
